import React, { Fragment } from "react";
import { Grid, Box } from "@mui/material";
import {
  CircleSVG,
  RightSideArrow,
  UpSideArrow,
  DownSideArrow,
} from "./CircleSVG";
import { RootState, useAppSelector } from "../../store/store";
import { useSelector } from "react-redux";
import { getNumberUnits } from "../../helper/service";
import { convertTemperatureToCelsius } from "../../config/util";
import DeviceInfoTooltip from "../common/DeviceInfoTooltip";
interface Props {
  item: any;
  variant?: any;
  location?: any;
  isRelatedData?: any;
  getSummaryData: (data: any, locationData: any, isRelatedData?: any) => void;
  index?: any;
}
export default function CardComponent({
  item,
  variant,
  location,
  isRelatedData,
  getSummaryData,
  index,
}: Props) {
  // define all States
  const {
    count = 0,
    substance,
    displayName,
    substanceKey,
    value,
    value1,
    unit,
    color,
    trend,
    providers
  } = item;
  let twoPlacedFloat =
    value != null
      ? Number.isInteger(value)
        ? value
        : parseFloat(value).toFixed(2)
      : "--";
  twoPlacedFloat =
    twoPlacedFloat != "--"
      ? getNumberUnits(twoPlacedFloat, substanceKey, unit)
      : "--";
  let twoPlacedFloat1 =
    value1 != null
      ? Number.isInteger(value1)
        ? value1
        : parseFloat(value1).toFixed(2)
      : "--";
  twoPlacedFloat1 =
    twoPlacedFloat1 != "--"
      ? getNumberUnits(twoPlacedFloat1, substanceKey, unit)
      : "--";
  let colorNew = color === "#C7C6C1" ? "#FFFFFF" : color;
  const { themeMode } = useSelector((state: RootState) => state.themeSlice);
  const userData = useAppSelector((store) => store?.authReducer?.userData);
  return (
    <>
      <Box
        key={index}
        className="tile"
        sx={{
          width: "auto",
          minWidth: "150px", // Ensures it doesn't shrink too much
          maxWidth: "100%",
          height: "72px",
          backgroundColor: "#fff",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          p: 1,
          m: 1,
          boxShadow: "0px 2.93827px 4.40741px rgba(0, 0, 0, 0.15)",
          borderRadius: "12px",
          textAlign: "center",
          fontSize: "0.875rem",
          fontWeight: "700",
          position: "relative",
          "&:hover": {
            backgroundColor: themeMode === "dark" ? "" : "#fafaff",
            opacity: [0.9, 0.8, 0.7],
            cursor: "pointer",
          },
        }}
        onClick={() => getSummaryData(item, location, isRelatedData)}
      >
        <div className="textInfo" style={{ display: "flex", flexDirection: "row", margin: "3px", }}>
          {/* <Box sx={{ position: "absolute", right: 0, top: 0.5 }} >
            <DeviceInfoTooltip providers={providers} fontsize={15} />
          </Box> */}
          <Box sx={{ pt: 1.4, pl: 1, pr: 0.5 }}>
            <CircleSVG
              getnumber={count !== 0 ? count.toString() : ""}
              bgcolor={colorNew}
              fontColor={""}
              themeMode={themeMode}
            />
          </Box>
          <div style={{ display: "flex", paddingTop: "15px", paddingLeft: "0px", paddingRight: "10px" }}>
            <div className="uparrow" style={{ marginRight: "9px" }}>
              {trend === "U" ? (
                <UpSideArrow fill={themeMode === "dark" ? "white" : "black"} />
              ) : trend === "D" ? (
                <DownSideArrow fill={themeMode === "dark" ? "white" : "black"} />
              ) : (
                ""
              )}
            </div>
            <div className="overview_text_info">{displayName || substance}</div>
            {/* Vertical Divider */}
            <div style={{
              width: "1px",
              height: "20px", // Adjust height as needed
              backgroundColor: "#ccc", // Adjust color as needed
              margin: "0 10px"
            }} />

            <div
              className="overview_text_info_sub"
              style={{ wordWrap: "break-word" }}
            >
              {(() => {
                if (substanceKey === "thir") return `${twoPlacedFloat1} ${unit}`;
                else if (substanceKey === "thi")
                  return (
                    <div className="main-thi" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', }}>
                      {/* <div className=""> */}
                      <div className="column-thi-color">A</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span>{twoPlacedFloat}</span>
                        <span>{unit}</span>
                      </div>
                      {/* </div> */}
                    </div>
                  );
                else if (substanceKey === "isopm10psd")
                  return item?.isoIndex || "-";
                else if (substanceKey === "temperature")
                  return (userData?.temperature_unit === "C" && parseFloat(twoPlacedFloat))
                    ? convertTemperatureToCelsius(twoPlacedFloat)?.value
                    : `${twoPlacedFloat} ${unit} `;
                else return `${twoPlacedFloat} ${unit} `;
              })()}
            </div>
          </div>
        </div>

      </Box>
    </>
  );
}
